<template>
  <div>
    <b-container>
      <nav-bar :title="'Approval'"></nav-bar>

      <alert-coin></alert-coin>

      <approval-criterion></approval-criterion>

    </b-container>
  </div>
</template>

<script>
  import navBar from "@/components/atmNavBar"
  import alertCoin from "@/components/atmAlertCoin"
  import approvalCriterion from "@/components/Checklist/atmAprovalCriterion";

  export default {
    components: {
      navBar,
      alertCoin,
      approvalCriterion
    },
    data: function () {
      return {
        idTask: this.$route.params,
        CoinsBanked: 15,
        points : [
            { 
                title : 'Total instances ON TASK',
                score : 5
            },
            { 
                title : 'Total instances OFF TASK',
                score : 12
            },
            { 
                title : 'Points earned',
                score : 35
            }
        ]
      }
    }
  }
</script>

<style scoped>
    .bg-green-light{
        background-color: #ECFBEC;
    }
    table tbody tr:nth-child(odd){
        background-color: #DEF9DE;
    }
    table tbody tr:nth-child(even){
        background-color: #BAF2BB;
    }
    .text-medium{
        font-size: 1.2em;
    }
    .text-medium{
      font-size: 2.5em;
    }
    .text-big{
      font-size: 6.5em;
    }
    .border-2-clear{
        border: 3px solid #DC3545;
    }
    .border-2-done{
        border: 3px solid #28A745;
    }
</style>